import styled from 'styled-components';

export const DIVIDER_HEIGHT = 1;
export const Base = styled.div`
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	min-height: 0;
`;

export const Divider = styled.div`
	height: ${DIVIDER_HEIGHT}px;
	background-color: ${({ theme }) => theme.gray['200']};
	flex-shrink: 0;
`;

export const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
`;

export const Spacer = styled.div`
	height: 20px;
	flex-shrink: 0;
`;

export const HalfSpacer = styled.div`
	height: 10px;
	flex-shrink: 0;
`;

export const LittleSpacer = styled.div`
	height: 4px;
	flex-shrink: 0;
`;

export const ScrollingContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	max-height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
`;
